
import EventEmitter from 'eventemitter3';
import uuid from 'uuid/v4';

class Context  {

  constructor(name = uuid()) {
    this.name = name;
    this.dispatcher = new EventEmitter({
      maxListener: Infinity
    });
  }

  executeAction(action, payload, callback) {
    return action(this, payload, callback);
  }

}

export default Context;



// WEBPACK FOOTER //
// ./src/js/app/context.js